var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Base error class that properly extends default Error class in TypeScript
 * By extending other errors from this one, you don't need to do additional manipulations
 * (e.g. override constructor, set prototype, set name, etc.)
 */
export class BaseError extends Error {
    constructor(message, options = {}) {
        super(message, options);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = this.constructor.name;
    }
}
export class ApiError extends BaseError {
    constructor(message, _a = {}) {
        var { statusCode } = _a, options = __rest(_a, ["statusCode"]);
        super(message, options);
        this.statusCode = statusCode;
    }
}
export class ApiTimeoutError extends ApiError {
}
//# sourceMappingURL=errors.js.map